import React from 'react'
import classNames from 'classnames'
import { ColumnsChildrenProps } from './Columns.d'
import ContentColumn from './ContentColumn/ContentColumn'

const OneColumnContent = ({
  columnContents = [],
  textColor,
  textAlignment,
  bgColor
}: ColumnsChildrenProps) => {
  const exportClass = classNames(
    'col-span-4 md:col-span-6 lg:col-span-12 grid',
    {
      'text-center justify-items-center': textAlignment === 'center',
      'text-left': textAlignment === 'left',
      'text-right': textAlignment === 'right',
      'style-light': bgColor === 'bg-brand-50' || bgColor === 'bg-blue-50'
    }
  )

  return (
    <div className={exportClass}>
      {columnContents[0].children.map((content: any, index: number) => {
        if (!content) return
        return (
          <ContentColumn
            component={content}
            key={index}
            type={content.typeHandle}
            textColor={textColor}
          />
        )
      })}
    </div>
  )
}

export default OneColumnContent
